import React from 'react';
import { Link } from 'react-router-dom';
import './Homework4.css';

const Homework5: React.FC = () => {
  const questions = [
    {
      id: 1,
      title: 'Butterworth Highpass Filter',
      description: 'Apply highpass filtering with thresholding and enhancement',
      path: '/homework/5/question1',
      color: '#8b5cf6'
    },
    {
      id: 2,
      title: 'Notch & Band Reject Filters',
      description: 'Remove moiré patterns and periodic noise using frequency domain filtering',
      path: '/homework/5/question2',
      color: '#ec4899'
    }
  ];

  return (
    <div className="homework4-container">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="content-wrapper">
        <Link to="/" className="back-button">
          ← Back to Hub
        </Link>

        <header className="homework4-header">
          <div className="badge">Homework 5</div>
          <h1>Frequency Domain Filtering</h1>
          <p className="subtitle">Butterworth Filters for Image Enhancement and Noise Removal</p>
        </header>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>FFT Processing</h3>
            <p>Fast Fourier Transform for frequency domain analysis</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔧</span>
            <h3>Butterworth Filters</h3>
            <p>Highpass, notch reject, and band reject filters</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎯</span>
            <h3>Edge Enhancement</h3>
            <p>Sharpen images and enhance details using highpass filtering</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🌀</span>
            <h3>Noise Removal</h3>
            <p>Remove periodic noise and moiré patterns with notch filters</p>
          </div>
        </div>

        <div className="questions-section">
          <h2>Select a Question</h2>
          <div className="questions-grid">
            {questions.map((question) => (
              <Link
                key={question.id}
                to={question.path}
                className="question-card"
                style={{ '--card-color': question.color } as React.CSSProperties}
              >
                <div className="question-number">Q{question.id}</div>
                <h3>{question.title}</h3>
                <p>{question.description}</p>
                <div className="card-arrow">→</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homework5;
